const tempEmailDomains = [
    'tempmail.com', '10minutemail.com', '10minutemail.net', 'guerrillamail.com',
    'guerrillamail.info', 'mailinator.com', 'throwaway.email', 'temp-mail.org',
    'temp-mail.io', 'temp-mail.com', 'temp-mail.ru', 'tempmail.org', 'tempmail.net',
    'tempmail.us', 'tempmail.io', 'tempmail.de', 'tempmail.fr', 'tempmail.es',
    'tempmail.it', 'tempmail.pt', 'tempmail.ru', 'trashmail.com', 'trashmail.net',
    'fakeinbox.com', 'fakeinbox.net', 'maildrop.cc', 'sharklasers.com', 'spam4.me',
    'spamgourmet.com', 'throwawaymail.com', 'dispostable.com', 'mailnesia.com',
    'maileater.com', 'getairmail.com', 'emailondeck.com', 'temp-sms.com',
    'mail.tm', 'temp.mail.com', 'mytrashmail.com', 'mail33.com', 'tossmail.com',
    'telemail.net', 'mintemail.com', 'yopmail.com', 'fake-mail.com', 'getnada.com',
    'tempinbox.com', 'throwawayemailaddress.com', 'trashmail.ws', 'mohmal.com',
    'fakemailgenerator.com', 'guerrillamailblock.com'
  ];
  
  export default tempEmailDomains;
  